import { render, staticRenderFns } from "./arbitraje.vue?vue&type=template&id=ea6bdfea&lang=html&"
import script from "./arbitraje.vue?vue&type=script&lang=js&"
export * from "./arbitraje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports